export function formatPrice(
  value: number,
  locale: string,
  currencyCode: string,
): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  });
  const amount = value / 100;

  if (locale !== "fa-IR") {
    return formatter.format(amount);
  }

  const parts = formatter.formatToParts(amount);
  const numericValue = parts
    .filter((part) => part.type !== "currency" && part.type !== "literal")
    .map((part) => part.value)
    .join("");
  const currency = parts.find((part) => part.type === "currency")?.value;

  return currency ? `${numericValue}\u00a0${currency}` : numericValue;
}
